import { ScaleLinear as d3ScaleLinear, ScaleTime as d3ScaleTime, ScalePoint as d3ScalePoint } from 'd3';
import { DotDatum } from '../../types';
import { DataPointProps, StyledDataPointProps } from '../DataPoint';
import { Theme, ValueOf } from '@redsift/design-system';

/**
 * Component's variant.
 */
export const DotVariant = {
  plain: 'plain',
  hollow: 'hollow',
} as const;
export type DotVariant = ValueOf<typeof DotVariant>;

/**
 * Component props.
 */
export interface DotProps extends DataPointProps<DotDatum> {
  /** A scale defined over a numeric/time/ordinal domain used to determine the x position based on the coordinates. */
  scaleX: d3ScaleLinear<number, number, never> | d3ScaleTime<number, number, never> | d3ScalePoint<string>;
  /** A linear continuous scale defined over a numeric domain used to determine the y position based on the coordinates. */
  scaleY: d3ScaleLinear<number, number, never>;
  /**
   * Variant.
   * @default 'plain'
   */
  variant?: DotVariant;
}

export type StyledDotProps = StyledDataPointProps &
  Omit<DotProps, 'scaleX' | 'scaleY'> & {
    $variant: DotProps['variant'];
    $theme: Theme;
  };
